import axiosInstance from "../api/axiosInstance";

// Density Part 4 — Events CMS (spec v1.0). Drafts may be partial; the
// backend enforces the full field set on publish.

export const fetchEvents = () => axiosInstance.get("/admin/events");

export const createEvent = (data) => axiosInstance.post("/admin/events", data);

export const updateEvent = (id, data) =>
  axiosInstance.put(`/admin/events/${id}`, data);

export const deleteEvent = (id) => axiosInstance.delete(`/admin/events/${id}`);

// Curiouzz Live, phase three: the coaster's question set (2026-09-15).
export const fetchLiveQuestions = () => axiosInstance.get("/admin/live-questions");
export const createLiveQuestion = (data) => axiosInstance.post("/admin/live-questions", data);
export const updateLiveQuestion = (id, data) => axiosInstance.put(`/admin/live-questions/${id}`, data);
export const deleteLiveQuestion = (id) => axiosInstance.delete(`/admin/live-questions/${id}`);
